import { FloatingFormItem, InputDate } from '@/components/_common';
import { usePortoScheduleAvailability } from '@/core/domain/workorder/porto-schedule/porto-schedule.hooks';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Alert, Col, Form, Row, Skeleton, Typography } from 'antd';
import moment from 'moment';
import { KanbanSchedulePortoFormValues } from '../form.types';
import { DateTimeFormat } from '@/utils/moment';
import { useEffect, useMemo } from 'react';
import ScheduleHourCard from '../../../../_common/ScheduleHourCard';

const { Title } = Typography;

interface Props {
  step: number;
}

export default function KanbanSchedulePortoFormScheduleDateFields(
  props: Props,
) {
  const form = Form.useFormInstance<KanbanSchedulePortoFormValues>();

  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const entryDate = Form.useWatch(['scheduleDate', 'entryDate'], form);
  const hourWatch = Form.useWatch(['scheduleDate', 'hour'], form);
  const capsCode = Form.useWatch(['general', 'capsCode'], form);
  const scheduleDuration = Form.useWatch(['general', 'scheduleDuration'], form);

  const portoScheduleAvailability = usePortoScheduleAvailability(
    {
      availabilityDate: entryDate?.format(DateTimeFormat),
      capsCodes: [capsCode],
      scheduleDuration: Number(scheduleDuration),
    },
    !!capsCode && !!scheduleDuration,
  );

  const hours = useMemo(
    () =>
      portoScheduleAvailability.data?.caps
        .at(0)
        ?.scheduleAvailability.find(
          (scheduleAvailabilityFind) =>
            scheduleAvailabilityFind.date === entryDate.format('DD-MM-YYYY'),
        )
        ?.timeSlots.map((time) => time.from),
    [portoScheduleAvailability.data, portoScheduleAvailability.dataUpdatedAt],
  );

  useEffect(
    () => form.setFieldValue(['scheduleDate', 'hour'], undefined),
    [entryDate],
  );

  return (
    <div style={{ display: props.step === 1 ? 'block' : 'none' }}>
      <Form.Item hidden name={['scheduleDate', 'hour']} />

      <Row gutter={[12, 12]}>
        {!hours?.length && (
          <Col span={24} style={{ marginBlock: 24 }}>
            <Alert
              style={{ padding: 24 }}
              type="warning"
              message="Dia selecionado não tem horários disponíveis"
            />
          </Col>
        )}

        <Col span={24} md={12}>
          <FloatingFormItem
            label="Data de entrada"
            name={['scheduleDate', 'entryDate']}
            initialValue={moment()}
            rules={[defaultEmptyFieldError]}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Skeleton active loading={portoScheduleAvailability.isLoading}>
          {!!hours?.length && (
            <Col span={24}>
              <div style={{ marginBottom: 18 }}>
                <Title level={4}>Horários disponíveis</Title>
              </div>

              <Row gutter={[12, 12]}>
                {hours.map((hour) => (
                  <Col span={24} md={6}>
                    <ScheduleHourCard
                      active={hourWatch === hour}
                      value={hour}
                      onClick={() =>
                        form.setFieldValue(['scheduleDate', 'hour'], hour)
                      }
                    />
                  </Col>
                ))}
              </Row>
            </Col>
          )}
        </Skeleton>

        <Col span={24} md={12}>
          <FloatingFormItem
            label="Previsão de entrega"
            name={['scheduleDate', 'estimatedLeaveDate']}
            rules={[defaultEmptyFieldError]}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>
      </Row>
    </div>
  );
}
